import {Component, Input} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import { ButtonDirective} from 'primeng/button';
import {PrimaryButton} from '@components/button/primary-button/primary-button';

@Component({
  selector: 'app-secondary-button',
  standalone: true,
  templateUrl: './secondary-button.html',
  imports: [
    TranslatePipe,
    ButtonDirective
  ],
  styleUrl: './secondary-button.scss'
})
export class SecondaryButton extends PrimaryButton {
}
